import React from 'react'

export default function Whoweare() {
  return (
    <>
      <div style={{marginTop: '60px'}}>
      <div className="carousel slide" data-bs-ride="carousel">
                <div className="carousel-inner">
                    <div className="carousel-item active">
                        <img src="assets/images/about-us-banner-1.jpg" className="d-none d-md-block w-100 img-fluid" alt="..." />
                        <img src="assets/images/Who we are-Mobile View.jpg" className="d-block d-md-none w-100 img-fluid"
                            alt="..." />
                    </div>
                </div>
            </div>
      </div>
      <div className="bg-light">
        <div className='container p-5 section-2-whoweare'>
          <p align='justify'>Amosta is a Technology Company, Committed to Cater The Requirements of THE PEOPLE to live a Better & Happy Life in era of Internet Of Things, Futuristic Smart Cities, Connected World & Super Intelligent Ecosystem.</p>
          <p align='justify'>Be it your business, your family, your organization, your field resources, your remote assets or your workforce, everything is now a DOT on big Matrix of connected world.</p>
          <p align='justify'>We Equip Businesses & Organizations with Our Well Researched Solutions to exceed their Productivity, Efficiency, ROI and Business Objectives.</p>
          <p align='justify'>With key Focus on Process Automation, Internet of Things ( IOT ), Manufacturing 2.0, Artificial Intelligence, Augmented Reality, Virtual Reality, Data Analysis & Smart Living, Amosta is firm to bring solutions to make this place a happier place to live.</p>
        </div>
      </div>
    </>
  )
}
